import { render } from "./MessageDetails.vue?vue&type=template&id=99c3d048&scoped=true"
import script from "./MessageDetails.vue?vue&type=script&lang=js"
export * from "./MessageDetails.vue?vue&type=script&lang=js"

import "./MessageDetails.vue?vue&type=style&index=0&id=99c3d048&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c3d048"]])

export default __exports__